import { render } from "./DeckPlan.vue?vue&type=template&id=5ddb981e&scoped=true"
import script from "./DeckPlan.vue?vue&type=script&lang=js"
export * from "./DeckPlan.vue?vue&type=script&lang=js"

import "./DeckPlan.vue?vue&type=style&index=0&id=5ddb981e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddb981e"]])

export default __exports__